module.exports = __webpack_public_path__ + "img/xin.f01aff4f.png";